// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":1,"codice":"...","tipologia":"...","umVendita":{"id":1,"simbolo":"mq"}}}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/unita-misura',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"simbolo":"mq","nome":"Metri quadrati"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/marche',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"nome":"..."}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/formati',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"nome":"..."}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi',
    requestBody: null,
    response: '{"data":[{"id":1,"ragioneSociale":"..."}],"total":0}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/prodotti',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"codice":"...","nome":"..."}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/coge/piano-conti/sottoconti-articoli',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"codice":"04.01.05","descrizione":"..."}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/collezioni',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"nome":"..."}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/:id/log',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"articoloId":1,"utenteId":1,"utenteName":"...","azione":"Modifica dati","dettaglio":"...","createdAt":"..."}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/:id/codici-cliente',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"articoloId":1,"clienteId":5,"codiceArticoloCliente":"ABC-123","cliente":{"id":5,"ragioneSociale":"...","nome":null,"cognome":null,"partitaIva":"..."}}]}'
  },
  {
    method: 'PUT',
    endpoint: '/api/anagrafiche/articoli/:id/codici-cliente/:codiceId',
    requestBody: null,
    response: '{"success":true,"data":{"id":1,"articoloId":1,"clienteId":5,"codiceArticoloCliente":"ABC-123","cliente":{"id":5,"ragioneSociale":"...","nome":null,"cognome":null,"partitaIva":"..."}}}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/articoli/:id/codici-cliente',
    requestBody: null,
    response: '{"success":true,"data":{"id":1,"articoloId":1,"clienteId":5,"codiceArticoloCliente":"ABC-123","cliente":{"id":5,"ragioneSociale":"...","nome":null,"cognome":null,"partitaIva":"..."}}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/anagrafiche/articoli/:id/codici-cliente/:codiceId',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/:id/riferimenti',
    requestBody: null,
    response: '{"success":true,"data":{"intercambiabiliComePadre":0,"intercambiabiliComeFiglio":0,"modelliConfigurazione":0,"articoliPreconfigurati":0,"componentiPreconfigurato":0,"capitolatiAccessorie":0,"capitolatiDistinti":0,"offerteAccessorie":0,"offerteDistinte":0,"righePreventivo":0,"componentiPreventivo":0,"preventiviDistinti":0,"totaleRiferimenti":0}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/anagrafiche/articoli/:id',
    requestBody: '{"tipologia":"...","umVenditaId":1,"umAcquistoId":1,"prodottoId":null,"sottotipoRicorrenzaDefault":null,"periodicitaDefault":null,"durataMesiDefault":null,"modalitaPagamentoDefault":null,"tariffaUnitariaDefault":null,"tariffaFissaTransazioneDefault":null,"percentualeTransazioneDefault":null}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/articoli/:id/duplica',
    requestBody: '{"codice":"..."}',
    response: '{"success":true,"data":{"id":1}}'
  },
  {
    method: 'PATCH',
    endpoint: '/api/anagrafiche/articoli/:id/attivo',
    requestBody: '{"attivo":true}',
    response: '{"success":true,"data":{"attivo":true}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/anagrafiche/articoli/:id',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/articoli/unita-misura',
    requestBody: '{"societaId":1,"simbolo":"...","nome":"..."}',
    response: '{"success":true,"data":{"id":1,"simbolo":"...","nome":"..."}}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/articoli/marche/find-or-create',
    requestBody: '{"societaId":1,"nome":"..."}',
    response: '{"success":true,"data":{"id":1,"nome":"..."}}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/articoli/collezioni/find-or-create',
    requestBody: '{"societaId":1,"marcaId":1,"nome":"..."}',
    response: '{"success":true,"data":{"id":1,"nome":"..."}}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/articoli/formati/find-or-create',
    requestBody: '{"societaId":1,"nome":"..."}',
    response: '{"success":true,"data":{"id":1,"nome":"..."}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
